exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Marck+Script&display=swap);", ""]);

// module
exports.push([module.id, ".font-script[data-v-ba4df4c6] {\n  font-family: 'Marck Script', cursive;\n}\n", ""]);

// exports
